import { IMultiLineBehavior, IMultiLineBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTypeSpecifiable } from "../../../beans/objects";

export class MultiLineBehaviorTranslator {
  from(bean: IObjectBeanTypeSpecifiable): IMultiLineBehavior {
    return {
      isEnable: (bean["@type"] === "2"),
    };
  }

  to(o: IMultiLineBehaviorSpecifiable) {
    return {
      type: o.multiLineBehavior.isEnable
        ? "2"
        : "1",
    };
  }
}
